import { useQuery } from 'react-query'

import {
  DEFAULT_PO_BILL_TO_CONTACT,
  SystemPreferenceKeys,
  systemPreferenceQueryConfig,
} from '@webapp/platform/iam'

export const useQueryPOBillToContact = () => {
  const { data, isLoading, isError } = useQuery(
    systemPreferenceQueryConfig.getValue(
      SystemPreferenceKeys.PO_BILL_TO_CONTACT
    )
  )

  return {
    // Also the value shown while loading or after a failure; check `isError`
    // before treating it as the saved setting
    value: data?.value ?? DEFAULT_PO_BILL_TO_CONTACT,
    isLoading,
    isError,
  }
}
